import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthLayout from './AuthLayout';
import InputField from './InputField';
import Button from './Button';
import UnverifiedAccountModal from './UnverifiedAccountModal';
import { LockIcon, MailIcon } from 'lucide-react';
const LoginPage = ({
  validateLogin,
  setCurrentEmail
}) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const handleSubmit = e => {
    e.preventDefault();
    if (!email || !password) {
      setError('Please fill in all fields');
      return;
    }
    const result = validateLogin(email, password);
    if (result.success) {
      setError('');
      alert('Login successful!');
    } else if (result.needsVerification) {
      setCurrentEmail(email);
      setShowModal(true);
    } else {
      setError(result.message);
    }
  };
  const handleVerifyAccount = () => {
    setShowModal(false);
    navigate('/verify');
  };
  const navigateToRegister = () => {
    navigate('/register');
  };
  const navigateToForgotPassword = () => {
    navigate('/forgot-password');
  };
  return <AuthLayout title="Sign In" data-id="element-88">
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-89">
        {error && <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6 rounded-lg" data-id="element-90">
            <div className="flex" data-id="element-91">
              <div className="flex-shrink-0" data-id="element-92">
                <svg className="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor" data-id="element-93">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" data-id="element-94" />
                </svg>
              </div>
              <div className="ml-3" data-id="element-95">
                <p className="text-sm text-red-700" data-id="element-96">{error}</p>
              </div>
            </div>
          </div>}

        <div className="space-y-5" data-id="element-97">
          <div className="relative" data-id="element-98">
            <InputField label="Email address" type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" data-id="element-99" />
            <div className="absolute right-4 top-3.5" data-id="element-100">
              <MailIcon size={20} className="text-blue-400" data-id="element-101" />
            </div>
          </div>

          <div className="relative" data-id="element-102">
            <InputField label="Password" type="password" name="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="********" data-id="element-103" />
            <div className="absolute right-4 top-3.5" data-id="element-104">
              <LockIcon size={20} className="text-blue-400" data-id="element-105" />
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between mt-6" data-id="element-106">
          <div className="flex items-center" data-id="element-107">
            <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-108" />
            <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700" data-id="element-109">
              Remember me
            </label>
          </div>
          <div className="text-sm" data-id="element-110">
            <button type="button" onClick={navigateToForgotPassword} className="font-medium text-blue-600 hover:text-blue-800" data-id="element-111">
              Forgot your password?
            </button>
          </div>
        </div>

        <div className="pt-3" data-id="element-112">
          <Button type="submit" fullWidth data-id="element-113">
            Sign In
          </Button>
        </div>

        <div className="mt-6" data-id="element-114">
          <div className="relative" data-id="element-115">
            <div className="absolute inset-0 flex items-center" data-id="element-116">
              <div className="w-full border-t border-gray-300" data-id="element-117"></div>
            </div>
            <div className="relative flex justify-center text-sm" data-id="element-118">
              <span className="px-2 bg-white text-gray-500" data-id="element-119">
                Or continue with
              </span>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-120">
            <button type="button" className="w-full flex justify-center py-2.5 px-4 border border-gray-300 rounded-xl shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-121">
              <svg className="h-5 w-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-122">
                <path d="M20.283 10.356h-8.327v3.451h4.792c-.446 2.193-2.313 3.453-4.792 3.453a5.27 5.27 0 0 1-5.279-5.28 5.27 5.27 0 0 1 5.279-5.279c1.259 0 2.397.447 3.29 1.178l2.6-2.599c-1.584-1.381-3.615-2.233-5.89-2.233a8.908 8.908 0 0 0-8.934 8.934 8.907 8.907 0 0 0 8.934 8.934c4.467 0 8.529-3.249 8.529-8.934 0-.528-.081-1.097-.202-1.625z" fill="#4285F4" data-id="element-123" />
              </svg>
            </button>
            <button type="button" className="w-full flex justify-center py-2.5 px-4 border border-gray-300 rounded-xl shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-124">
              <svg className="h-5 w-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-125">
                <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z" fill="#3b5998" data-id="element-126" />
              </svg>
            </button>
          </div>
        </div>

        <div className="text-center mt-6" data-id="element-127">
          <p className="text-base text-gray-600" data-id="element-128">
            Don't have an account?{' '}
            <button type="button" onClick={navigateToRegister} className="font-medium text-blue-600 hover:text-blue-800" data-id="element-129">
              Sign up
            </button>
          </p>
        </div>
      </form>

      {showModal && <UnverifiedAccountModal email={email} onVerify={handleVerifyAccount} onClose={() => setShowModal(false)} data-id="element-130" />}
    </AuthLayout>;
};
export default LoginPage;